	document.addEventListener("turbo:load", () => {
    const container = document.getElementById("fundraiser_embed_modal");
    if (!container)
      return;

    console.log("Load: embeds/fundraiser_preview.js");

    $("#embed_code, #embed_copy").on("click", function() {
      $("#embed_was_copied").slideUp();
      var code = document.getElementById("embed_code");
      code.select();
      code.setSelectionRange(0, 99999);
      document.execCommand("copy");
      code.blur();
      if (window.getSelection) { // All browsers, except IE <=8
        window.getSelection().removeAllRanges();
      } else if (document.selection) { // IE <=8
        document.selection.empty();
      }
      $("#embed_was_copied").slideDown();
    });

    $("#embed_close, #embed_modal_outer").on("click", function(e) {
      if(e.target !== e.currentTarget) return;
      $("#embed_modal_outer").fadeOut();
    })

    // $("#embed_preview").click(function(e) {
    // 	e.preventDefault();
    // 	return false;
    // });
})